//Margin conventions
		var margin = {top: 20, right: 5, bottom: 20, left: 45};
		var widther = d3.select(".gia-chart").node().clientWidth;
		var width = widther - margin.left - margin.right,
		    height = 370 - margin.top - margin.bottom;

		//Parses date for correct time format
		var parseDate = d3.time.format("%Y").parse; 

		//Format tick 
		var format = d3.format("0,000"); 

		//Appends the svg to the chart-container div
		var svg = d3.select(".gia-chart").append("svg")
			.attr("width", width + margin.left + margin.right)
			.attr("height", height + margin.top + margin.bottom)
			.append("g")
			.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

		//Creates the xScale 
			var xScale = d3.scale.ordinal()
				.rangeRoundBands([0, width], .25);

			//Creates the yScale
			var yScale = d3.scale.linear()
				.range([height, 0]);

			//Defines the y axis styles
			var yAxis = d3.svg.axis()
				.scale(yScale)
				.tickSize(-width)
				.tickPadding(8)
				.tickFormat(function(d) { return format(d);})
				.orient("left"); 

		//Loads the data
		d3.csv("data/cases.csv", ready);

		function ready(err, data) {
			if (err) throw "error loading data";
			console.log(data)

			//FORMAT data
			data.forEach(function(d) {
				d.cases = +d.cases;
		    	d.year = parseDate(d.year);
			});

		  	//Sets min and max on xScale
		  	var xMin = d3.min(data, function(d) { return d.year;});
		  	var xMax = d3.max(data, function(d) { return d.year;});
		  	var yMin = d3.min(data, function(d) { return d.cases;});
		  	var yMax = d3.max(data, function(d) { return d.cases;});

		  	//Defines the x axis styles
		  	var xAxis = d3.svg.axis()
		    	.scale(xScale)
		    	.tickSize(height)
		    	.tickPadding(8)
		    	.orient("bottom")
		    	.tickFormat(d3.time.format("%Y")); 

  			//Sets scale domains
  			xScale.domain(data.map(function(d) { return d.year; }));
  			yScale.domain([0, yMax]);
			
  			//Binds the data to the bars      
  			var bar = svg.selectAll(".bar")
  			  	.data(data)
  			  	.enter()
  			  	.append("rect")
  			  	.attr("class", "bar")
  			  	.attr("x", function(d) { return xScale(d.year); })
  			  	.attr("width", xScale.rangeBand())
  			  	.attr("y", function(d) { return yScale(d.cases); })
  			  	.attr("height", function(d) { return height - yScale(d.cases); })
  			  	.classed("current", function(d) { return d.year == xMax});
			
  			//Appends the y axis
			var yAxisGroup = svg.append("g")
				.attr("class", "y axis")
				.call(yAxis)
    			.selectAll("g")
    			.classed("g-baseline", function(d) { return d == 0 });

    		//Appends the y axis
			var xAxisGroup = svg.append("g")
				.attr("class", "x axis")
				.call(xAxis);	

			//Binds data to labels
			var labelGroup = svg.selectAll("g-num")
			    .data(data)
			    .enter()
			    .append("g")
			    .attr("class", "g-label-group")
			    .attr("transform", function(d) {
			      return "translate(" + xScale(d.year) + ",-7)";
			    });

			//Appends first bar labels   
			var barLabels = labelGroup.append("text") 
			    .text(function(d) {return  format(d.cases);})
			    .attr("y", function(d) { return yScale(d.cases); })
			    .attr("x", xScale.rangeBand()/2)
			    .attr("text-anchor", "middle")
			    .attr("class", "g-labels");   
     	
  		
  			//RESPONSIVENESS
  			d3.select(window).on("resize", resized);
  			
  			function resized() {

			//new margin
    			var newMargin = {top: 20, right: 5, bottom: 20, left: 45};

    			var newWidther = d3.select(".gia-chart").node().clientWidth;

    			var newWidth = newWidther - newMargin.left - newMargin.right;

    			//Change the width of the svg
    			d3.select("svg")
      				.attr("width", newWidth + newMargin.left + newMargin.right);

    			//Change the xScale
    			xScale
    			  .rangeRoundBands([0, newWidth], .25);

    			//Update the bars
    			d3.selectAll("rect")
    			  .attr("x", function(d) { return xScale(d.year); })
    			  .attr("width", xScale.rangeBand())

    			//Updates bar labels
  				labelGroup
  					.attr("transform", function(d) {
			      		return "translate(" + xScale(d.year) + ",-7)";
			    	});

			    barLabels
			    	.attr("x", xScale.rangeBand()/2);	  

    			//Updates xAxis
    			d3.selectAll(".x.axis")
         			.call(xAxis);   

    			//Updates ticks
    			xAxis
     			 .scale(xScale);

    			//Updates yAxis  
    			d3.selectAll(".y.axis")
      				.call(yAxis); 

    			yAxis
      				.tickSize(-newWidth);
  				};
		}
